import './oidc.scss';

import jwtDecode from 'jwt-decode';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';

import encryptor from '../../../lib/utils/encryptor';
import { getHashValue } from '../../../lib/utils/qol';
import { authActions } from '../../../store/slices/auth';
import { getTempConnection } from '../../../store/utils/authStorage';

const OidcPage = () => {
    const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();

    const redirect = useCallback(() => {
        history.replace({ pathname: location.state?.from?.pathname || '/' });
    }, [history, location.state]);

    const logout = useCallback(() => {
        history.replace({pathname: '/login' });
    }, [history]);

    useEffect(() => {
        if (isAuthenticated) {
            redirect();
        }
    }, [isAuthenticated, redirect]);

    useEffect(() => {
        if (!isAuthenticated) {
            const idToken = getHashValue('id_token', location.hash);
            const idTokenDecrypted = jwtDecode(idToken);

            const tempConnection = getTempConnection();
            const oidcNonce = encryptor.decrypt(tempConnection.oidcNonce);

            if(oidcNonce !== idTokenDecrypted.nonce) {
                toast.error("NONCE on token doesn't match NONCE sent to the authentication server.");
                logout();
                return;
            }

            const connection = {
                name: tempConnection.name,
                graphqlEndpoint: encryptor.decrypt(tempConnection.graphqlEndpoint),
                oidcIssuer: encryptor.decrypt(tempConnection.oidcIssuer),
                oidcClientId: encryptor.decrypt(tempConnection.oidcClientId),
                authType: 'oidc'
            };

            dispatch(authActions.CONNECTED_VIA_OIDC({
                oidcConnection: connection,
                idToken,
            }));
        }
    }, [dispatch, location, isAuthenticated, logout]);

    return (
        <div>
            <span>Loading...</span>
        </div>
    );
};


export default OidcPage;